import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Teaching Plan for Plants Unit"
      description="A teacher's guide to teaching Stile's Plants unit"
      slug={props.location.pathname}
    />
  );
}

function TeachingPlanPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Plants Unit Teaching Plan"
        subtitle="A teacher's guide to teaching Stile's Plants unit."
        id="TEACHING_GUIDE"
        redirectUrl="https://stileapp.com/go/plant_teaching_plan"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/curriculum/plants_tp.jpg"
            alt="Plants Unit Teaching Plan"
          />
        }
      >
        <p>
          The Plants Teaching Plan outlines the phenomena, storyline and career profile for the
          unit, as well as the list of lessons, labs and assessments. Use it to see Stile's
          pedagogical model in practice.
        </p>
        <p>
          The Teaching Plan also provides information about pre-requisite student knowledge, a guide
          to the assessments in the unit, and session-by-session lesson plans.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default TeachingPlanPage;
